import {
  ANNUAL_BALANCE_SHEET_TOTAL_VALUE_43_MIO_OR_LESS,
  ANNUAL_BALANCE_SHEET_TOTAL_VALUE_MORE_THAN_43_MIO,
  ANNUAL_TURNOVER_VALUE_MORE_THAN_50_MIO,
  NUMBER_OF_EMPLOYEES_VALUE_250_OR_MORE,
  NUMBER_OF_EMPLOYEES_VALUE_10_OR_LESS,
  NUMBER_OF_EMPLOYEES_VALUE_10_TO_50,
  NUMBER_OF_EMPLOYEES_VALUE_50_TO_249,
  ANNUAL_TURNOVER_VALUE_50_MIO_OR_LESS
} from './enums'

export const countsAsBigCompany = ({
  numberOfEmployees,
  annualTurnover,
  annualBalanceSheetTotal
}) =>
  numberOfEmployees === NUMBER_OF_EMPLOYEES_VALUE_250_OR_MORE ||
  annualTurnover === ANNUAL_TURNOVER_VALUE_MORE_THAN_50_MIO ||
  annualBalanceSheetTotal === ANNUAL_BALANCE_SHEET_TOTAL_VALUE_MORE_THAN_43_MIO

export const countsAsSmallCompany = ({
  numberOfEmployees,
  annualTurnover,
  annualBalanceSheetTotal
}) =>
  (
    numberOfEmployees === NUMBER_OF_EMPLOYEES_VALUE_10_OR_LESS ||
    numberOfEmployees === NUMBER_OF_EMPLOYEES_VALUE_10_TO_50 ||
    numberOfEmployees === NUMBER_OF_EMPLOYEES_VALUE_50_TO_249
  ) &&
  annualTurnover === ANNUAL_TURNOVER_VALUE_50_MIO_OR_LESS &&
  annualBalanceSheetTotal === ANNUAL_BALANCE_SHEET_TOTAL_VALUE_43_MIO_OR_LESS
